import React, { useState, useRef } from "react";
import { Box, IconButton } from "@mui/material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { NavLink } from "react-router-dom";
import { connect } from 'react-redux';
import { Flipper } from "react-flip-toolkit";
import DropdownContainer from "../dropdownContainer";
import { useHoverDropdown } from "../dropdownContainer/useHoverDropdown";

const navLinkSx = {
    textDecoration: 'underline',
    color: 'blue',
    display: 'block',
    padding: '16px 8px',
    width: '100%',
    fontSize: '1.1em',
    fontWeight: 'bold',
    textAlign: 'center',
    textTransform: 'uppercase',
    '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)'
    }
};

const AccountMenu = ({ isAuthenticated, handleAuthChildClick }) => {
  const duration = 300;
  const { isOpen, animatingOut, onMouseEnter, onMouseLeave, closeMenu } = useHoverDropdown(duration);

  const handleItemClick = () => {
    if (handleAuthChildClick) {
        handleAuthChildClick();
    }
    closeMenu();
  }

  return (
    <Flipper flipKey={isOpen}>
      <Box
        sx={{ position: "relative", display: "inline-block" }}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      >
        <IconButton sx={{ p: 0 }}>
          <AccountCircleIcon fontSize="large" sx={{ color: "white" }} />
        </IconButton>
        {isOpen && (
          <Box sx={{ position: "absolute", top: "100%", left: "50%", transform: "translateX(-50%)", zIndex: 1, mt: "0px" }}>
            <DropdownContainer animatingOut={animatingOut} duration={duration}>
              <Box sx={{ width: '100px', py: 1, overflow: 'hidden', borderRadius: '4px', px: 0 }}>
                {isAuthenticated ?
                  <Box component={NavLink} to="/logout" onClick={handleItemClick} sx={navLinkSx}>LOGOUT</Box> :
                  <>
                    <Box component={NavLink} to="/login" onClick={handleItemClick} sx={navLinkSx}>LOGIN</Box>
                    <Box component={NavLink} to="/signup" onClick={handleItemClick} sx={navLinkSx}>SIGNUP</Box>
                  </>
                }
              </Box>
            </DropdownContainer>
          </Box>
        )}
      </Box>
    </Flipper>
  );
};

const mapStateToProps = (state) => ({
    isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps)(AccountMenu);
